export const AUTH_LOGGED_IN = 'AUTH_LOGGED_IN';
export const AUTH_LOG_OUT = 'AUTH_LOG_OUT';
export const SET_AFTER_LOGIN = 'SET_AFTER_LOGIN';
export const REMOVE_AFTER_LOGIN = 'REMOVE_AFTER_LOGIN';
export const UPDATE_USER_CREDIT = 'UPDATE_USER_CREDIT';
export const UPDATE_COMPANY_ONLINE = 'UPDATE_COMPANY_ONLINE';
export const TOKEN_LOADING = 'TOKEN_LOADING';
